import React, { useState } from 'react';
import { X } from 'lucide-react';
interface GetStartedFormProps {
  isOpen: boolean;
  onClose: () => void;
}
export function GetStartedForm({
  isOpen,
  onClose
}: GetStartedFormProps) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    useCase: ''
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formData);
    // In a real implementation, this would send data to a backend service
    // that would forward the information to ramzad@rawfounders.com
    alert(`Thank you for your interest! Your information has been sent to ramzad@rawfounders.com. We'll be in touch soon.`);
    // Reset form
    setFormData({
      name: '',
      email: '',
      company: '',
      useCase: ''
    });
    onClose();
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-240">
      <div className="bg-white rounded-xl w-full max-w-md relative" data-id="element-241">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" data-id="element-242">
          <X size={24} data-id="element-243" />
        </button>
        <div className="p-6" data-id="element-244">
          <h2 className="text-2xl font-bold mb-4" data-id="element-245">
            Get Started with Agentter.ai
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-246">
            Fill out this form to start your free trial and transform your
            business with AI.
          </p>
          <form onSubmit={handleSubmit} data-id="element-247">
            <div className="space-y-4" data-id="element-248">
              <div data-id="element-249">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-250">
                  Full Name
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-251" />
              </div>
              <div data-id="element-252">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-253">
                  Business Email
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-254" />
              </div>
              <div data-id="element-255">
                <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-256">
                  Company Name
                </label>
                <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-257" />
              </div>
              <div data-id="element-258">
                <label htmlFor="useCase" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-259">
                  What would you like to automate?
                </label>
                <textarea id="useCase" name="useCase" value={formData.useCase} onChange={handleChange} rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-260"></textarea>
              </div>
              <button type="submit" className="w-full bg-black text-white py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors" data-id="element-261">
                Start Free Trial
              </button>
            </div>
          </form>
          <p className="text-sm text-gray-500 mt-4 text-center" data-id="element-262">
            No credit card required. 14-day free trial.
          </p>
        </div>
      </div>
    </div>;
}